import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { config } from '@app/core/app-config';
import { ApiResponse } from '@app/shared/interfaces/lib/api.interface';
import { map, Observable } from 'rxjs';

export interface CommunityPostAuthor {
  name: string | null;
  avatar: string | null;
}

export interface CommunityPostStats {
  likes: number;
  comments: number;
}

export interface CommunityPost {
  id: string;
  title: string;
  excerpt?: string | null;
  author: CommunityPostAuthor;
  url: string; // relative path like /community/slug
  published_at: string | null;
  tags?: string[] | null;
  content_type?: string | null;
  is_promoted?: boolean;
  stats: CommunityPostStats;
}

export interface CommunityPostsResponseMeta {
  count: number;
}

@Injectable({ providedIn: 'root' })
export class CommunityService {
  private readonly url = `${config.API_URL}/community/popular-posts`;

  constructor(private readonly http: HttpClient) {}

  getPopularPosts(): Observable<CommunityPost[]> {
    return this.http
      .get<ApiResponse<CommunityPost[], CommunityPostsResponseMeta>>(this.url)
      .pipe(map((res) => res.data ?? []));
  }
}
